// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/sass/style-rtl.scss
// module id = 587
// module chunks = 376